<script>
	
</script>

<div class="loading">
	loading
</div>

<style>
	.loading {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		margin: auto;
		animation: fade 3s infinite;
	}

	@keyframes fade {
		0% { opacity: 0; }
		50% { opacity: 1; }
		100% { opacity: 0; }
	}

</style>